// extracted by mini-css-extract-plugin
export default {"form":"SummaryAttributeViewerControl_form__dO2S0"};